import { Component } from '@angular/core';
import { SvcBtnIconBaseComponent } from '../svc-btn-icon-base.component';
import { MatRipple } from '@angular/material/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[svc-btn-icon]',
  templateUrl: './svc-btn-icon.component.html',
  styleUrls: ['./svc-btn-icon.component.scss'],
  hostDirectives: [{ directive: MatRipple, inputs: ['matRippleDisabled:disabled'] }],
  host: {
    '[class.svc-btn-icon]': `true`,
    '[class.svc-btn-icon-danger]': `color === 'danger'`,
    '[class.svc-btn-icon-text]': `color === 'text'`,
    '[class.svc-btn-icon-primary]': `color === 'primary'`,
    '[class.svc-btn-icon-on-primary]': `color === 'on-primary'`,
    '[class.svc-btn-icon-disabled]': `disabled`,
  },
})
export class SvcBtnIconComponent extends SvcBtnIconBaseComponent {}
